(function () {
  if (!window.MHL) return;
  var M = window.MHL;

  function isRestrictedVariant(id) {
    return M.restrictedVariantIds.indexOf(parseInt(id, 10)) !== -1;
  }

  function extractVariantId(body) {
    if (!body) return null;
    if (body instanceof FormData) return parseInt(body.get('id'), 10);
    if (typeof body === 'string') {
      try { return parseInt(JSON.parse(body).id, 10); } catch (e) {}
      var m = body.match(/(?:^|&)id=(\d+)/);
      return m ? parseInt(m[1], 10) : null;
    }
    if (typeof body === 'object' && body.id) return parseInt(body.id, 10);
    return null;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function blockResponse(msg) {
    return new Response(
      JSON.stringify({ status: 422, message: msg, description: msg }),
      { status: 422, headers: { 'Content-Type': 'application/json' } }
    );
  }

  function evaluateBlock(cart) {
    var hasRestricted = false, hasDuplicate = false;
    cart.items.forEach(function (i) {
      var matches = i.handle === M.restrictedHandle || isRestrictedVariant(i.variant_id);
      if (matches) {
        hasRestricted = true;
        if (i.quantity > 1) hasDuplicate = true;
      }
    });
    return {
      blocked: (M.customerIsSubscribed && hasRestricted) || hasDuplicate,
      hasRestricted: hasRestricted
    };
  }

  function refreshBlockUI() {
    return fetchCart().then(function (cart) {
      var state = evaluateBlock(cart);

      // Hide/show all banners
      document.querySelectorAll('.mhl-cart-block').forEach(function (el) {
        el.style.display = state.blocked ? '' : 'none';
      });

      // Re-render the cart footer's CTA block so the disabled button swaps back to submit
      var footer = document.getElementById('main-cart-footer');
      if (footer && footer.dataset.id) {
        return fetch('/?sections=' + footer.dataset.id)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data[footer.dataset.id];
            if (!html) return;
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newCtas = doc.querySelector('.cart__ctas');
            var oldCtas = document.querySelector('#main-cart-footer .cart__ctas');
            if (newCtas && oldCtas) oldCtas.replaceWith(newCtas);
          })
          .catch(function () {});
      }
    });
  }

  var origFetch = window.fetch;
  var cartUpdateEndpoints = ['/cart/change', '/cart/update', '/cart/clear'];

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    // Block restricted /cart/add (existing behavior)
    if (url.indexOf('/cart/add') !== -1) {
      var variantId = extractVariantId(init && init.body);
      if (isRestrictedVariant(variantId)) {
        if (M.customerIsSubscribed) {
          return Promise.resolve(blockResponse(
            "You're already an active Operative. Manage from your dossier."
          ));
        }
        return fetchCart().then(function (cart) {
          var has = cart.items.some(function (i) {
            return i.handle === M.restrictedHandle || isRestrictedVariant(i.variant_id);
          });
          if (has) return blockResponse('Only one Operative Access per cart.');
          return origFetch.apply(window, [input, init]);
        });
      }
    }

    // Refresh banner + CTA after any cart-modifying call resolves
    var isUpdate = cartUpdateEndpoints.some(function (ep) { return url.indexOf(ep) !== -1; });
    var promise = origFetch.apply(this, arguments);

    if (isUpdate) {
      promise.then(function (response) {
        if (response && response.ok) setTimeout(refreshBlockUI, 50);
      }).catch(function () {});
    }

    return promise;
  };
})();